import _ from 'lodash';
import React, { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormInputContainer, FormContext, FormInputToolbar } from 'blaze-form';
import PropTypes from 'prop-types';
import BlazeInputReactSelect from 'blaze-input-react-select';
import Skeleton from 'react-loading-skeleton';
import ApiService from '../../../services/ApiService';

const getFormatOption = formatName => {
  switch (formatName) {
    case 'color':
      // eslint-disable-next-line
      return ({ label, color }) => (
        <div>
          {color && <i className="fas fa-circle" style={{ color, paddingRight: '3px' }} />}&nbsp;{label}
        </div>
      );
    // case 'user':
    //   return ({ displayName }) => {
    //     if (!displayName) {
    //       return <div>&nbsp;</div>;
    //     }

    //     return <div>{displayName}</div>;
    //   };
    case 'taxdistrict':
      return ({ id, districtName, districtRate }) => {
        if (!id) {
          return <div>&nbsp;</div>;
        }

        return (
          <div>
            {districtName} - <em>{districtRate}%</em>
          </div>
        );
      };
    case 'LoyaltyCustomer':
      return ({ id, firstName, lastName }) => {
        if (!id) {
          return <div>&nbsp;</div>;
        }

        return (
          <div>
            {firstName} {lastName}
          </div>
        );
      };
    default:
      return ({ label, ...rest }) => {
        if (!label) {
          return <div>&nbsp;</div>;
        }

        if (rest.description) {
          return (
            <div>
              <div>
                <strong>{label}</strong>
              </div>
              <div className="description">
                <i>{rest.description}</i>
              </div>
            </div>
          );
        }

        return <div>{label}</div>;
      };
  }
};

const modelRoutes = {
  Salesperson: '/users',
  QuoteState: '/crm/states',
  TaxDistrict: '/crm/districts',
  QuoteAddon: '/crm/addons',
  QuoteFee: '/crm/fees',
  QuoteWarranty: '/crm/warranties',
  QuoteCost: '/crm/costs',
  QuoteTaxExempt: '/crm/taxexempt',
  LoyaltyCustomer: '/search/db/loyaltycustomer',
};

const FormInputDbSelect = ({ search = {}, field, ...props }) => {
  const { user } = useSelector(state => state.app);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [validationKeyValue, setValidationKeyValue] = useState(_.get(props.search, 'keyValue'));

  const { ee } = useContext(FormContext);

  const consume = ({ action, payload: data }) => {
    if (action === 'sync') {
      if (search.key && data[search.key]) {
        setValidationKeyValue(data[search.key].data);
      }
    }
  };

  const toolbarCallback = newValue => {
    // console.log(newValue);
  };

  const getOptions = () => {
    if (search.modelName === 'Branch') {
      if (search.allBranches) {
        setOptions([
          { label: 'All Branches', value: '0' },
          ...user.branches.map(branch => ({ label: branch.name, value: String(branch.id) })),
        ]);
      } else {
        setOptions(user.branches.map(branch => ({ label: branch.name, value: String(branch.id) })));
      }

      setLoading(false);
      return Promise.resolve();
    }

    const defaultUrl = `/db/${search.modelName}`;

    // TODO Custom Urls should probably be a prop instead
    let customUrl = modelRoutes[search.modelName];

    if (search.url) {
      customUrl = search.url;
    }

    if (!search.params) {
      search.params = {
        filterByBranch: search.filterByBranch,
      };
    }

    if (search.filterByBranch) {
      search.params.where = btoa(
        JSON.stringify({
          branchId: user?.branch?.id,
        })
      );
    }

    // TODO Probably shouldn't live here
    if (search.modelName && search.modelName.toLowerCase() === 'loyaltycustomer' && validationKeyValue) {
      search.params.filter = btoa(JSON.stringify({ customerNum: validationKeyValue.toLowerCase() }));
    }

    return ApiService.get(customUrl || defaultUrl, { params: search.params || {} })
      .then(response => {
        const list = _.get(response, 'data.list') || response.data || [];

        // Previously used filterOption for user searching because 'label' wasn't set, however having filterOption set doesn't
        // allow 'creatable' to work for whatever reason, probably needs some logic set up in isValidNewOption callback?
        // either way this gives a user list a proper label so all things work

        const newOptions = list.map(o => ({
          ...o,
          label: o.displayName || o.label || o.name,
          value: String(o.id !== undefined ? o.id : o.value),
          isDisabled: o.disabled === true,
        }));

        if (!field.noEmptyOption) {
          newOptions.unshift(search.emptyOption || { label: '', value: '' });
        }

        setOptions(newOptions);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatOptionLabel = getFormatOption(search.format || search.modelName);

  useEffect(() => {
    if (ee) {
      ee.on('syncForm', (...args) => {
        setTimeout(() => {
          consume(...args);
        }, 10);
      });
    }

    return () => {
      if (ee) {
        ee.off('syncForm');
      }
    };
  }, []);

  useEffect(() => {
    getOptions();
  }, [validationKeyValue]);

  const inputProps = field.inputProps || {};

  if (formatOptionLabel) {
    inputProps.formatOptionLabel = formatOptionLabel;
  }

  const creatable = search.optional || _.get(field, 'props.creatable');

  if (loading) {
    return (
      <FormInputContainer {...props} field={{ ...field, inputProps: { ...inputProps, formatOptionLabel } }}>
        <Skeleton style={{ height: '35px', lineHeight: 'inherit' }} />
      </FormInputContainer>
    );
  }

  return (
    <>
      <BlazeInputReactSelect
        {...props}
        loading={loading}
        creatable={creatable}
        field={{
          ...field,
          options,
          inputProps: { ...inputProps, formatOptionLabel },
        }}
        // value={options[0]}
      />
      <FormInputToolbar toolbar={_.get(field, 'toolbar')} callback={toolbarCallback} />
    </>
  );
};

FormInputDbSelect.propTypes = {
  field: PropTypes.object,
  search: PropTypes.object,
};

export default FormInputDbSelect;
